//IMPORTANT:: Date Format: SEP 06 2023 
export const events = [
       {'id': '17',
      'date':'FEB 05 2026',
      'title':"Basic Drone workshop and Global Education opportunities",
      'time':'10:00 am - 12:00 pm',
       'venue':'Sangamam Hall',
    //    'organizer':'Alagappa Incubation Forum and Gms Drone services',
        status: 'due',
        // cal_link: '#'
    },
    {
        'id': '16',
        'date': 'FEB 03 2026',
        'title': "Thegidi-Freshers Association",
        'time': '4.45 pm',
        'venue': 'Gallery Hall',
        'status': 'due',
        
    },

    {
        'id': '15',
        'date': 'JAN 12 2026',
        'title': "சமத்துவப் பொங்கல் திருவிழா",
        'time': '08:00 am',
        'venue': 'திறந்தவெளி அரங்கம்',
        // 'status': 'due'
    },
    {
        'id': '15',
        'date': 'OCT 30 & 31 2025',
        'title': "CENCON - by CIVIL Association",
        'time': '10:00 am',
        'venue': 'Murugappa Hall',
        'details': 'A National Level Technical Symposium',
        // 'status': 'due'
    },
    {
        'id': '13',
        'date': 'OCT 29 & 30 2025',
        'title': "ALCONESY - by EEE Association",
        'time': '10:00 am',
        'venue': 'Murugappa Hall',
        'details': 'A National Level Technical Symposium',
        // 'status': 'due'
    },
    {
        'id': '13',
        'date': 'OCT 28 2025',
        'title': "Inauguration - by Freshers' Association",
        'time': '04:45 - 06:00 pm',
        'venue': 'Murugappa Hall',
        'details': 'Freshers Association Inauguration Ceremony',
        // 'status': 'due'

    },
    //{
    //    'id': '13',
    //    'date': 'OCT 27 2025',
     //    'title': "Inauguration - by ISTE of ACGCET",
     //    'time': '04:00 pm',
      //   'venue': 'Murugappa Hall',
     //    'details': 'ISTE Inauguration Ceremony',
        // 'status': 'due'
    // },
    // {
    //     'id': '13',
    //     'date': 'OCT 25 2025',
    //     'title': "ROBO SOCCER WORKSHOP - by Freshers' Association",
    //     'time': '10:00 am',
    //     'venue': 'Gallery Hall',
    //     'details': 'A workshop on Robo Soccer to enhance technical skills',
    //     // 'status': 'due'
    // },

    // {
    //     'id': '15',
    //     'date': 'OCT 23 & 24 2025',
    //     'title': "SHACKLES - by MECH Association",
    //     'time': '10:00 am',
    //     'venue': 'Murugappa Hall',
    //     'details': 'A National Level Technical Symposium',
    //     // 'status': 'due'
    // },
    // {
    //     'id': '15',
    //     'date': 'OCT 15 & 16 2025',
    //     'title': "SYGNELS - by ECE Association",
    //     'time': '10:00 am',
    //     'venue': 'ECE Department',
    //     'details': 'A National Level Technical Symposium',
    //     // 'status': 'due'
    // },




    // {
    //     'id': '13',
    //     'date': 'OCT 15 2025',
    //     'title': "Graphic Designing Workshop - by Freshers' Association",
    //     'time': '4.45 pm',
    //     'venue': 'Gallery Hall',
    //     'details': 'A workshop on Graphic Designing to enhance technical skills',
    //     // 'status': 'due'
    // },




    // {
    //     'id': '14',
    //     'date': 'OCT 14 2025',
    //     'title': "அகழ் - by முத்தமிழ் மன்றம்",
    //     'time': '09:30 am',
    //     'venue': 'Murugappa Hall',
    //     'details': 'Mandram Function',
    //     // 'status': 'due'
    // },
    // {
    //     'id': '15',
    //     'date': 'OCT 13 2025',
    //     'title': "COGNOBLAZE - by CSE Association",
    //     'time': '10:00 am',
    //     'venue': 'CSE Department',
    //     'details': 'A National Level Technical Symposium',
    //     // 'status': 'due'
    // },
    // {
    //     'id': '16',
    //     'date': 'OCT 13 2025',
    //     'title': "Inaguration Ceremony - Rotaract Club of ACGCET",
    //     'time': '4.00 pm',
    //     'venue': 'Murugappa Hall',
    //     'details': '',
    //     // 'status': 'due'
    // },
    // {
    //     'id': '15',
    //     'date': 'OCT 09 2025',
    //     'title': "AURA'25 - by Music Club",
    //     'time': '03:00 pm',
    //     'venue': 'Murugappa Hall',
    //     'details': 'Music Fest',
    //     // 'status': 'due'
    // },


    // {
    //     'id': '13',
    //     'date': 'SEP 20 2025',
    //     'title': "ARDUINO WORKSHOP - by Freshers' Association of ACGCET",
    //     'time': '10:00 am',
    //     'venue': 'Gallery Hall',
    //     'details': 'A workshop on Arduino to enhance technical skills',

    // },
    // {
    //     'id': '12',
    //     'date': 'SEP 9 2025',
    //     'title': "CODE QUEST - by CSE Association",
    //     'time': '03:00 pm',
    //     'venue': 'ACCETOSA Building',
    //     'details': 'A coding contest to improve coding skills',
    //     //  'status':'due'
    // },
    // {
    //     'id': '11',
    //     'date': 'SEP 09 2025',
    //     'title': "Freshers Party - by Freshers' Association of ACGCET",
    //     'time': '09:30 am',
    //     'venue': 'Murugappa Hall',
    //     'details': 'An exclusive party for freshers',
    //     //  'status':'due'
    // },
    // {
    //     'id': '10',
    //     'date': 'SEP 04 2025',
    //     'title': "Inspire'25 - by Rotaract Club",
    //     'time': '02:45 pm',
    //     'venue': 'Sangamam Hall',
    //     'details': 'An exclusive event for teachers',

    // },
    // {
    //     'id': '9',
    //     'date': 'AUG 19 2025',
    //     'title': "CODE QUEST - by CSE Association",
    //     'time': '11:00 am',
    //     'venue': 'ACCETOSA Building',
    // },
    // {
    //     'id': '8',
    //     'date': 'AUG 11 2025',
    //     'title': "Campus Tour for Freshers by Freshers Association of ACGCET",
    //     'time': '09:20 am',
    //     'venue': 'ACGCET campus',
    // },
    // {
    //     'id': '7',
    //     'date': 'AUG 11 - AUG 19 2025',
    //     'title': "Freshers' Welcome & Induction Programme",
    //     'time': '09:20 am',
    //     'venue': 'Murugappa Hall',
    // },
    // {
    //     'id': '6',
    //     'date': 'JULY 31 2025',
    //     'title': "CODE QUEST - by CSE Association",
    //     'time': '03:00 pm',
    //     'venue': 'Training and Placement Centre(Saaral)',
    //     'details': "",
    // },

    // {
    //     'id': '4',
    //     'date': 'JULY 15 & 16 2025',
    //     'title': "Orientation Programme",
    //     'time': '09:30 am',
    //     'venue': 'Murugappa Hall',
    // },
    // {
    //     'id': '3',
    //     'date': 'JULY 11&12 2025',
    //     'title': "Workshop on Effective Public Speaking Skills by Thiran",
    //     'time': '09:30 am',
    //     'venue': 'ECE block',
    //     'details': "",
    // },
    // {
    //     'id': '2',
    //     'date': 'JULY 8 2025',
    //     'title': "Mechanical Association Orientation",
    //     'time': '09:30 am',
    //     'venue': 'Sangamam Hall',
    //     'details': "",
    // },
    // {
    //     'id': '1',
    //     'date': 'APRIL 6 2025',
    //     'title': "Thiran Prize Distribution",
    //     'time': '09:30 am',
    //     'venue': 'Murugappa Hall',
    //     'details': "",
    // },
    // {
    //     'id': '20',
    //     'date': 'NOV 11 2024',
    //     'title': "Aura -by Music Club",
    //     'time': '03:00 pm',
    //     'venue': 'Murugappa Hall',
    //     'details': "We cordially invite you for Music club"
    // },
    // {
    //     'id': '21',
    //     'date': 'NOV 10 2024',
    //     'title': "Lubber pandhu -by Rotaract Club",
    //     'time': '09:00 am',
    //     'venue': 'Murugappa Hall',
    //     'details': "We cordially invite you for Lubber Pandhu"
    // },

    //     {
    //         'id': '18',
    //         'date': 'NOV 07 2024',
    //         'title': "Agal -by Muthamizh Mandram",
    //         'time': '09:30 am',
    //         'venue': 'Murugappa Hall',
    //         'details': "We cordially invite you for Congnoblaze'24"
    //     },
    //     {
    //         'id': '15',
    //         'date': 'NOV 06 2024',
    //         'title': " ECE Inter Symposium Sygnels",
    //         'time': '09:00 am',
    //         'venue': 'Murugappa Hall',
    //         'details': "We cordially invite you for Sygnels'24"
    //     },
    //     {
    //         'id': '11',
    //         'date': 'NOV 05 2024',
    //         'title': "MEC Intra Symposium Fuels'25",
    //         'time': '09:00 am',
    //         'venue': 'Murugappa Hall',
    //         'details': "We cordially invite you for Fuels'24"
    //     },
    //     {
    //         'id': '16',
    //         'date': 'OCT 24 2024',
    //         'title': "CIV Intra Symposium Cesar",
    //         'time': '09:00 am',
    //         'venue': 'Sangamam Hall',
    //         'details': "We cordially invite you for Cesar'24"
    //     },
    //     {
    //         'id': '17',
    //         'date': 'OCT 22,23 2024',
    //         'title': "EEE Inter Symposium Alconsy",
    //         'time': '09:00 am',
    //         'venue': 'Murugappa Hall',
    //         'details': "We cordially invite you for Alconsy'24"
    //     },
    //     {
    //         'id': '14',
    //         'date': 'OCT 21 2024',
    //         'title': "CSE Inter Symposium Cognoblaze",
    //         'time': '09:00 am',
    //         'venue': 'Sangamam Hall',
    //         'details': "We cordially invite you for Congnoblaze'24"
    //     },
    //     {
    //     'id':'13',
    //     'date':'SEP 10 2024',
    //     'title':'Campus Tour for Freshers',
    //     'time':'03:30 pm',
    //     'venue':'Murugappa Hall',
    //     'details':'Freshers! Explore the campus'
    // },
    // {
    //     'id':'12',
    //     'date':'MAR 27 2024',
    //     'title':"ACMARA RIVALRY'24",
    //     'time':'03:30 pm',
    //     'venue':'Acgcet Ground',
    //     'details':'We cordially invite you for ACMARA RIVALRY\'24, 68th intra level sports day',
    //     // 'status':'due'
    // },
    // {
    //     'id':'11',
    //     'date':'NOV 24 2023',
    //     'title':"Deftera'23",
    //     'time':'09:30 am',
    //     'venue':'CSE Department ',
    //     'details':'We cordially invite you for Deftera\'23',
    //     //  'status':'due'
    // },
    // {
    //     'id':'10',
    //     'date':'NOV 08 2023',
    //     'title':'16th Rotaract Club Installation',
    //     'time':'04:45 pm',
    //     'venue':'Sangamam Hall ',
    //     'details':'We cordially invite you for the 16th Installation of our Club',
    //     // 'status':'due'
    // },
    // {
    //     'id':'9',
    //     'date':'NOV 04 2023',
    //     'title':'Box Cricket - by Rotaract club',
    //     'time':'09:30 am',
    //     'venue':'College Playgound',
    //     'details':'Mini Boundary Cricket Tournament for boys',
    //     // 'status':'due'
    // },
    // {
    //     'id':'8',
    //     'date':'NOV 04 2023',
    //     'title':'Epicolours - by Rotaract club',
    //     'time':'09:30 am',
    //     'venue':'Final Year Girls\' Hostel',
    //     'details':'An artistic event exclusively for girls',
    //     // 'status':'due'
    // },
    // {
    //     'id':'7',
    //     'date':'NOV 04 2023',
    //     'title':'Diwali Donation Camp - by Rotaract club',
    //     'time':'10:00 am',
    //     'venue':'R.H. Welfare School of Differently-abled, Karaikudi',
    //     'details':'Let\'s celebrate this diwali by helping the needy',
    //     // 'status':'due'
    // },
    // {
    //     'id':'6',
    //     'date':'OCT 05 2023',
    //     'title':'Jumanji - by Rotaract club',
    //     'time':'04:45 pm',
    //     'venue':'Gallery Hall',
    //     'details':'Fun team event for 1st year students',
    //     // 'status':'due'
    // },
    // {
    //     'id':'5',
    //     'date':'SEP 24 2023',
    //     'title':'Project Magizh Day 2 - by Rotaract club and Music Club',
    //     'time':'05:30 pm',
    //     'venue':'Soodamanipuram park',
    //     'details':'A Musical fund raising event !'
    // },
    // {
    //     'id':'4',
    //     'date':'SEP 23 2023',
    //     'title':'Project Magizh Day 1 - by Rotaract Club and Music Club',
    //     'time':'05:30 pm',
    //     'venue':'Soodamanipuram park',
    //     'details':'A Musical fund raising event !'
    // },


]